import { Action, createReducer, on } from '@ngrx/store';
import * as MetadataMgmtActions from '../actions';
import {
  IBulkValueUploadResponse,
  IMetadataKeyList,
  IMetadataSourceType,
  IMetadataTagKey,
} from '../../models/Metadata-mgmt';
import { IDjangoErrors } from '../../../../shared/models/DjangoErrors';

export interface MetadataMgmtState {
  sourceTypes: IMetadataSourceType[];
  metadataKeys: IMetadataKeyList[];
  metadataTagKeys: IMetadataTagKey[];
  loading: boolean;
  errors: IDjangoErrors | null;
  uploadInProgress: boolean;
  uploadResult: IBulkValueUploadResponse | null;
}

const initialState: MetadataMgmtState = {
  sourceTypes: [],
  metadataKeys: [],
  metadataTagKeys: [],
  loading: false,
  errors: null,
  uploadInProgress: false,
  uploadResult: null,
};

export const metadataMgmtReducer = createReducer(
  initialState,
  on(MetadataMgmtActions.MetadataMgmtUiActions.GetSourceTypes, (state) => ({
    ...state,
    loading: true,
    errors: null,
  })),
  on(MetadataMgmtActions.MetadataMgmtApiActions.getSourceTypesSuccess, (state, { payload }) => ({
    ...state,
    sourceTypes: payload,
    loading: false,
    errors: null,
  })),
  on(MetadataMgmtActions.MetadataMgmtApiActions.getSourceTypesError, (state, { errors }) => ({
    ...state,
    sourceTypes: [],
    loading: false,
    errors,
  })),
  on(MetadataMgmtActions.MetadataMgmtUiActions.GetMetadataKeys, (state) => ({
    ...state,
    loading: true,
    errors: null,
  })),
  on(MetadataMgmtActions.MetadataMgmtApiActions.getMetadataKeysSuccess, (state, { payload }) => ({
    ...state,
    metadataKeys: payload,
    loading: false,
    errors: null,
  })),
  on(MetadataMgmtActions.MetadataMgmtApiActions.getMetadataKeysError, (state, { errors }) => ({
    ...state,
    metadataKeys: [],
    loading: false,
    errors,
  })),
  on(MetadataMgmtActions.MetadataMgmtUiActions.CreateMetadataKey, (state) => ({
    ...state,
    loading: true,
    errors: null,
  })),
  on(MetadataMgmtActions.MetadataMgmtApiActions.createMetadataKeySuccess, (state, { payload }) => ({
    ...state,
    metadataKeys: [...state.metadataKeys, payload],
    loading: false,
    errors: null,
  })),
  on(MetadataMgmtActions.MetadataMgmtApiActions.createMetadataKeyError, (state, { errors }) => ({
    ...state,
    loading: false,
    errors,
  })),
  on(MetadataMgmtActions.MetadataMgmtUiActions.UpdateMetadataKey, (state) => ({
    ...state,
    loading: true,
    errors: null,
  })),
  on(MetadataMgmtActions.MetadataMgmtApiActions.updateMetadataKeySuccess, (state, { payload }) => ({
    ...state,
    metadataKeys: state.metadataKeys.map((key) => (key.id === payload.id ? payload : key)),
    loading: false,
    errors: null,
  })),
  on(MetadataMgmtActions.MetadataMgmtApiActions.updateMetadataKeyError, (state, { errors }) => ({
    ...state,
    loading: false,
    errors,
  })),
  on(MetadataMgmtActions.MetadataMgmtUiActions.DeleteMetadataKey, (state) => ({
    ...state,
    loading: true,
    errors: null,
  })),
  on(MetadataMgmtActions.MetadataMgmtApiActions.deleteMetadataKeySuccess, (state, { metadataKeyId }) => ({
    ...state,
    metadataKeys: state.metadataKeys.filter((key) => key.id !== metadataKeyId),
    loading: false,
    errors: null,
  })),
  on(MetadataMgmtActions.MetadataMgmtApiActions.deleteMetadataKeyError, (state, { errors }) => ({
    ...state,
    loading: false,
    errors,
  })),
  on(MetadataMgmtActions.MetadataMgmtApiActions.getMetadataTagKeysSuccess, (state, { payload }) => ({
    ...state,
    metadataTagKeys: payload,
  })),
  on(MetadataMgmtActions.MetadataMgmtApiActions.getMetadataTagKeysError, (state, { errors }) => ({
    ...state,
    metadataTagKeys: [],
    errors,
  })),
  on(MetadataMgmtActions.MetadataMgmtUiActions.UploadMetadataValuesCsv, (state) => ({
    ...state,
    uploadInProgress: true,
    uploadResult: null,
    errors: null,
  })),
  on(MetadataMgmtActions.MetadataMgmtApiActions.uploadMetadataValuesCsvSuccess, (state, { payload }) => ({
    ...state,
    uploadInProgress: false,
    uploadResult: payload,
    errors: null,
  })),
  on(MetadataMgmtActions.MetadataMgmtApiActions.uploadMetadataValuesCsvError, (state, { errors }) => ({
    ...state,
    uploadInProgress: false,
    errors,
  })),
  on(MetadataMgmtActions.MetadataMgmtUiActions.ResetUploadResult, (state) => ({
    ...state,
    uploadResult: null,
    errors: null,
  }))
);

export function MetadataMgmtReducer(state: MetadataMgmtState | undefined, action: Action) {
  return metadataMgmtReducer(state, action);
}
